interface IProps {
    type: "account" | "card"
}

const ProfileSkeleton = ({ type }: IProps) => {
    const skeletonType = (key: string) => {
        switch (key) {
            case "account":
                return (
                    <div className="flex animate-pulse flex-col gap-10">
                        <div className="hidden items-center gap-5 md:flex">
                            <div className="h-[78px] w-[78px] rounded-full bg-[#F7F6FF] dark:bg-[#33276F]"></div>
                            <div className="h-7 w-[150px] rounded-md bg-[#F7F6FF] dark:bg-[#33276F]"></div>
                        </div>
                        <div className="grid w-full items-start gap-5 md:grid-cols-2">
                            <div className="h-[34px] w-full rounded-md bg-[#F7F6FF] dark:bg-[#33276F]"></div>
                            <div className="h-[34px] w-full rounded-md bg-[#F7F6FF] dark:bg-[#33276F]"></div>
                            <div className="h-[34px] w-full rounded-md bg-[#F7F6FF] dark:bg-[#33276F]"></div>
                            <div className="h-[34px] w-full rounded-md bg-[#F7F6FF] dark:bg-[#33276F]"></div>
                            <div className="h-[34px] w-full rounded-md bg-[#F7F6FF] dark:bg-[#33276F]"></div>
                            <div className="h-[34px] w-full rounded-md bg-[#F7F6FF] dark:bg-[#33276F]"></div>
                            <div className="h-[34px] w-full rounded-md bg-[#F7F6FF] dark:bg-[#33276F]"></div>
                            <div className="h-[34px] w-full rounded-md bg-[#F7F6FF] dark:bg-[#33276F]"></div>
                        </div>
                        <div className="h-[34px] w-full rounded-md bg-[#F7F6FF] dark:bg-[#33276F] md:w-[200px]"></div>
                    </div>
                )
            case "card":
                return (
                    <div className="flex flex-col gap-5">
                        <div className="flex justify-center gap-5 md:justify-start">
                            <div className="h-[36px] w-[80px] rounded-md bg-[#F7F6FF] dark:bg-[#33276F]"></div>
                            <div className="h-[36px] w-[80px] rounded-md bg-[#F7F6FF] dark:bg-[#33276F]"></div>
                        </div>
                        <div className="grid w-full animate-pulse items-start gap-5 md:grid-cols-2">
                            <div className="h-[244px] w-full rounded-md bg-[#F7F6FF] dark:bg-[#33276F]"></div>
                            <div className="h-[244px] w-full rounded-md bg-[#F7F6FF] dark:bg-[#33276F]"></div>
                        </div>
                    </div>
                )
            default:
                break
        }
    }

    return <div>{skeletonType(type)}</div>
}

export default ProfileSkeleton
